import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { AuthRole } from '../../shared/types';
import { useAuth } from '../contexts/AuthContext';
import { LoadingScreen } from './Ui';

export function ProtectedRoute({ children, roles }: { children: ReactNode; roles?: AuthRole[] }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingScreen label="Validando sesión…" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) {
    const fallback = user.role === 'super_admin' ? '/admin' : user.role === 'reception' ? '/dashboard/reception' : user.role === 'kitchen' ? '/dashboard/kitchen' : user.role === 'delivery' ? '/dashboard/delivery' : user.role === 'waiter' ? '/dashboard/waiter' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
